import { createAction } from 'redux-actions'

export const setIsRosterApproved = createAction('approval/roster')
export const setAreUploadColorsApproved = createAction('approval/uploadColors')
export const setIsFinalApproved = createAction('approval/final')
export const resume = createAction('resume')
